<script>
    import { writable } from 'svelte/store';
    import { setContext } from 'svelte';
    import { query, result } from '../stores';

    let tabs = writable([]);
    setContext("tabs", tabs);
</script>

<ul class="nav nav-tabs" id="myTab" role="tablist">
    {#each $tabs as {tab_id, label} (tab_id)}
        <li class="nav-item">
            <a class="nav-link" on:click|preventDefault={() => query.setActive(tab_id)} class:active={$query.active === tab_id} id="documenti-tab"
               href="#documenti" role="tab" aria-controls="documenti"
               aria-selected="false">{label}<span>{$result[tab_id] ? $result[tab_id].total : 0}</span></a>
        </li>
    {/each}
</ul>
<div class="tab-content" id="myTabContent">
    <slot></slot>
</div>
